export const TEMPLATE_SPREADSHEET_IDS = {
  'Roller - Feature - Hebrew': '1cSut0MmmKTrieD1RPAEYfQtsjuMChdyjk88ZTa6Yw18',
  'Roller - Feature - Bilingual': '1mjbBspApME5Wngqr2Dv0Yt0BTADqoPRiDZj-EHARbRA',
  'Roller - Short - Hebrew': '1-LMXdRg_hs4x0Wg5EdOCMYBPogDPFpFXZS1IJr7ysAg',
  'Roller - Short - English': '1iFvMLnC6Y9zyPiqE2hvo_1Q8qW78rJNo-iN7LtPy25c',
  'Roller - Short - Bilingual': '170DQfqOBcIS8AkXj96oG--mycj9IkWfCVROqzar84os',
  'Closing credits Sequence Bilingual (cards)': '1KcwWRQDtF9Sh4lRLdHOpAqKCAvD_41_t7kk5sLmcTYc',
  'Closing credits Sequence Hebrew (cards)': '1F-R6Vl3qzprpXNBeryn00sUIlmQ_Fh2Q6kNGT45WjxE',
  'Closing credits Sequence English (cards)': '1gHVY-D3rZsGa3TXhGxDy552mh5kgl0DtrSzv80FXvds',
  'Cards - Opening Sequence - Hebrew': '1U0pTJSbFmZ8Z9OQZ7fi68DdBiKQ0RzEqk6VsuHtUY6k',
  'Cards - Opening Sequence - English': '1S0zATk-SRIggdM9F0kHOkE8ZaJoX_qzmRUUvU9lnRbQ',
  'Cards - Opening Sequence - Bilingual': '1HybeRAd_7klENSjIy7sAWmcZPeioolVZFmbCgoo9IFA',
} as const;

export type TemplateName = keyof typeof TEMPLATE_SPREADSHEET_IDS;

export const TEMPLATE_NAMES: TemplateName[] = Object.keys(TEMPLATE_SPREADSHEET_IDS) as TemplateName[];

export function getTemplateSpreadsheetId(name: TemplateName): string {
  return TEMPLATE_SPREADSHEET_IDS[name];
}
